export default __webpack_public_path__ + "static/media/newLogo.c342f94e.png";